export default __webpack_public_path__ + "static/images/3bda409e.png";